import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import numeral from 'numeral'
import VueColumnsResizable from 'vue-columns-resizable';
import './registerServiceWorker';
import { MsalApp } from './msal';

Vue.use(VueColumnsResizable);

// auto require generic components so we don't have to import it
// file starts with _ will be auto import...
// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
    // Look for files in the current directory
    './components',
    // Do not look in subdirectories
    false,
    // Only include "_" prefixed .vue files
    /_[\w]+\.vue$/
)

// For each matching file name...
requireComponent.keys().forEach((fileName) => {
    // Get the component config
    const componentConfig = requireComponent(fileName)
    // Get the PascalCase version of the component name
    const componentName = fileName
        // Remove the "./_" from the beginning
        .replace(/^\.\/_/, '')
        // Remove the file extension from the end
        .replace(/\.\w+$/, '')

    // Globally register the component
    Vue.component(componentName, componentConfig.default || componentConfig)
})

Vue.config.productionTip = false

// filters
Vue.filter('formatNumber', function(value) {
    if (value) {
        // return Number(value).toLocaleString()
        return numeral(value).format("(0,0.00)")
    }
})

MsalApp.handleRedirectPromise().then(handleResponse).catch(error => {
    console.log(error);
});

function handleResponse(resp) {
    let accountId = "";
    if (resp !== null) {
        // fresh login
        console.log('Fresh login!')
        accountId = resp.account.homeAccountId;
    } else {
        const currentAccounts = MsalApp.getAllAccounts();
        if (!currentAccounts || currentAccounts.length < 1) {
            // need login
            MsalApp.loginRedirect({ scopes: ['User.Read'] })
        } else if (currentAccounts.length > 1) {
            // choose account code here
        } else if (currentAccounts.length === 1) {
            // previously logged in
            console.log("Previously logged in")
            accountId = currentAccounts[0].homeAccountId;
        }
    }
    // initialize vue if user has logged in
    if (accountId) {
        MsalApp.$accountId = accountId;
        window.vue = new Vue({
            router,
            store,
            // axios,
            render: h => h(App),
        }).$mount('#app')
    }
}